var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.586,
    height: 20.001,
    viewBox: "0 0 19.586 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6036.819,1.716l-2.829-2.828a.5.5,0,0,1-.146-.352.5.5,0,0,1,.146-.355l2.829-2.828a.5.5,0,0,1,.353-.146.5.5,0,0,1,.354.146.5.5,0,0,1,0,.706l-1.977,1.977h17.588a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-17.584l1.973,1.974a.5.5,0,0,1,0,.706.5.5,0,0,1-.354.147A.5.5,0,0,1-6036.819,1.716Z",
    transform: "translate(14.793 6040.001) rotate(90)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6023.888,1.717a.5.5,0,0,1,0-.706l1.975-1.975H-6039.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h17.585l-1.974-1.975a.5.5,0,0,1,0-.706.5.5,0,0,1,.706,0l2.829,2.829a.5.5,0,0,1,.146.352.5.5,0,0,1-.146.355l-2.829,2.827a.494.494,0,0,1-.353.147A.491.491,0,0,1-6023.888,1.717Z",
    transform: "translate(1.864 6040) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.04163a05b4aaf9779dba9b13261cee3c.svg";
export { ForwardRef as ReactComponent };